<div class="DocContainer">
  <div class="LeftFacet">
    @if (this.productListService.selectedTabIndex| async; as tabIndex) {
    @if (tabIndex === 7) {
    <app-facet-navigation></app-facet-navigation>
    }
    }
  </div>
  <div class="rightSectionDoc">
    <div class="formSectionTop">
      <h1 class="myProfileTopHeader">
        Documents and Media Library
      </h1>
      <div class="myProfileBody">
        <form [formGroup]="docSearchForm" (ngSubmit)="search(0,20,'')">
          <div class="row document-search-section">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label" for="search">Search</label>
              <div class="col-12 px-0 docInputSearch">
                <input #searchInput type="text" formControlName="searchKey" (input)="onSearchInput($event)"
                  (keydown.enter)=" onSearchInput($event);onSearch($event);clearRecentSearch()"
                  (keyup)="onSearchInput($event)" (focus)="onSearchInput($event)" (click)="onSearchInput($event)"
                  placeholder='Enter Document Name....'>
                <!--  <ul class="RecentSearch RecentSearchDOCPopUP" *ngIf="recentSearches.length > 0">
                  <p class="RecentSearchText">Recent Searches</p>
                  <p *ngFor="let search of recentSearches" class="RecentSearch-item">
                    <a (click)="populateSearchInput(search.value)"
                    class="RecentSearch-anchor">{{search.value}}</a>
                  </p>
                </ul> -->
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label" for="select">Category</label>
              <div class="selectBox">
                <select formControlName="productCategory">
                  <option value="null" [selected]="form.productCategory.value==null">
                    Please select</option>
                  @for (item of ApiDataSearch?.documentCategoryList; track item) {
                  <option [value]="item">
                    {{item}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="row document-search-section">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label" for="select">Document and Media Type</label>
              <div class="selectBox">
                <select formControlName="docType">
                  <option value="null" [selected]="form.docType.value==null">
                    Please select</option>
                  @for (item of ApiDataSearch?.documentTypeDataList ; track item) {
                  <option [value]="item?.documentCode">
                    {{item?.documentNameLoc}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label" for="select">Product Group</label>
              <div class="selectBox"><select formControlName="docProductGroup">
                  <option value="null" [selected]="form.docProductGroup.value==null">
                    Please select</option>
                  @for (item of ApiDataSearch?.docProductGroup ; track item) {
                  <option [value]="item">{{item}}
                  </option>
                  }
                </select></div>
            </div>
          </div>
          <!--   <div class="row document-search-section">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
            <label class="software-search-label" for="select">Additional Text</label>
            <div class="selectBox">
              <select formControlName="documentAddText">
                <option value="null" [selected]="form.documentAddText.value==null">
                Please select</option>
                <option *ngFor="let item of ApiDataSearch?.documentAddText " [value]="item">
                {{item}}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
            <label class="software-search-label" for="select">Supplement Text</label>
            <div class="selectBox"><select formControlName="documentSuppText">
              <option value="null" [selected]="form.documentSuppText.value==null">
              Please select</option>
              <option *ngFor="let item of ApiDataSearch?.documentSuppText " [value]="item">
                {{item}}
              </option>
            </select></div>
          </div>
        </div> -->
          <div class="buttonsContainer mt-4">
            <div>
              <button (click)="reset()" type="button" class="btn btn-blue reset-btn">Reset</button>
            </div>
            <div class="">
              <button class="btn btn-primary search-btn" type="submit">Search
                <img src="icons/link-grey.svg" width="20px"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="bottomSectionPDP">
      <section class="cx-page-section">
        @if (productListService.seperateDocDetails$|async; as docModel) {
        <div class="container1">
          @if (docModel?.kbRailDocumentsCounts ) {
          <div class="row1">
            @if (viewMode$ | async; as viewMode) {
            <div class="">
              <div class="nyab-kb-cx-sorting top">
                <div class="action-row sorting-block">
                  <label
                    class="d-none d-md-none d-lg-block col-lg-3 total-records">{{docModel?.pagination?.totalResults}}
                    Item(s) Found</label>
                  @if (docModel && docModel?.pagination) {
                  <label>
                    @if ((docModel.pagination?.totalResults??0) >90 || (docModel.pagination?.totalResults??0) >30) {
                    <label class="col-lg-3 pagination">View
                      @if ((docModel.pagination?.totalResults??0) >30) {
                      <a class="page-size" [routerLink]="" (click)="changePageSize(30)"> &nbsp;30&nbsp;
                      </a>
                      } @if ((docModel.pagination?.totalResults??0) >90) {
                      <span class="d-flex">or
                        <a class="page-size" [routerLink]="" (click)="changePageSize(90)">
                          &nbsp;90&nbsp;
                        </a></span>
                      }
                      Item(s)</label>
                    }</label>
                  }
                  @if (!isMobile) {
                  <div class="sort-select">
                    <label class="sort-by">
                      <span>Sort by:</span>
                    </label>
                    <div class="col-lg-4 sorting">
                      <cx-sorting [sortOptions]="docModel.sorts" (sortListEvent)="sortList($event, docModel)"
                        [selectedOption]="docModel.pagination?.sort"
                        [ariaLabel]="'productList.sortResults' | cxTranslate" ariaControls="product-results-list"
                        placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                      </cx-sorting>
                    </div>
                  </div>
                  }
                  @if (isMobile) {
                  <div class="d-flex col-12 doc-search-filter">
                    <div class="col-4 doc-left-search-filter">
                      <app-facet-navigation></app-facet-navigation>
                    </div>
                    <div class="col-8 sort-select">
                      <label class="sort-by">
                        <span>Sort by: </span>
                      </label>
                      <div class="sorting">
                        <cx-sorting [sortOptions]="docModel.sorts" (sortListEvent)="sortList($event, docModel)"
                          [selectedOption]="docModel.pagination?.sort"
                          [ariaLabel]="'productList.sortResults' | cxTranslate" ariaControls="product-results-list"
                          placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                        </cx-sorting>
                      </div>
                    </div>
                  </div>
                  }
                  <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn ml-auto">
                    <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode">
                    </cx-product-view>
                  </div>
                </div>
              </div>
              <div id="product-results-list" class="cx-product-container">
                <!-- Product list when using pagination -->
                @if (!isInfiniteScroll) {
                @if (viewMode === ViewModes.Grid) {
                <div class="row">
                  @for (product of docModel?.kbRailDocuments; track product) {
                  <app-kb-document-grid [product]="product" [searchQuery]="helightText"
                    class="col-12 col-sm-12 col-md-12 col-lg-3">
                  </app-kb-document-grid>
                  }
                </div>
                }
                @if (viewMode === ViewModes.List) {
                @for (product of docModel?.kbRailDocuments; track product) {
                <app-kb-document-list [product]="product" [searchQuery]="helightText" class="cx-product-search-list">
                </app-kb-document-list>
                }
                }
                } @else {
                <cx-product-scroll [scrollConfig]="scrollConfig" [model]="docModel"
                  [inputViewMode]="viewMode"></cx-product-scroll>
                }
                <!-- Product list when using infinite scroll -->
              </div>
              <div class="nyab-kb-cx-sorting bottom">
                <div class="row col-md-12">
                  <label class="col-md-5">Showing
                    {{ ((docModel?.pagination?.pageSize || 0) * (docModel?.pagination?.currentPage||
                    0))+1 }}-
                    @if (((docModel?.pagination?.pageSize || 0) *((docModel?.pagination?.currentPage || 0)+1) )
                    < (docModel.pagination?.totalResults || 0)) { <span>{{
                      (docModel?.pagination?.pageSize || 0)
                      *((docModel?.pagination?.currentPage || 0)+1)}}</span>
                      }
                      @if (((docModel?.pagination?.pageSize || 0) *((docModel?.pagination?.currentPage || 0)+1) )
                      > (docModel?.pagination?.totalResults || 0)) {
                      <span>{{docModel?.pagination?.totalResults}}</span>
                      }
                      of
                      {{docModel?.pagination?.totalResults}}
                      results
                  </label>
                  @if (!isInfiniteScroll) {
                  <div class="col-auto col-md-7 d-flex justify-content-end align-items-center pr"
                    [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                    <div class="kb-pagination">
                      <kb-pagination [pagination]="docModel.pagination" [defaultPage]="0"
                        (viewPageEvent)="changePageCustom($event,docModel)">
                      </kb-pagination>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="document-not-found">No Results found.
          </div>
          }
        </div>
        }
      </section>
    </div>
  </div>
</div>